module.exports = __webpack_public_path__ + "img/chehulu8.35713db2.jpg";